(function ($, window, document, undefined) {
Navigation = ( function() {

	function Constructor() {
		
		this.start = function () { 
		};
		
	}
	return new Constructor();
	
}() );
})(jQuery, window, document); 